import * as React from 'react';

interface ReportIssueIconProps extends React.SVGProps<SVGSVGElement> {
  size: number;
  color: string;
}

export default function ReportIssueIcon({ size = 24, color = '#047dba' }: ReportIssueIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width={size} height={size}>
      <defs>
        <style>
          {`.cls-1 {
              fill: none;
          }
          
          .cls-1, .cls-2 {
            stroke-width: 0px;
          }
          
          .cls-2 {
            fill: ${color};
          }`}
        </style>
      </defs>
      <g id="icons">
        <g>
          <path
            className="cls-2"
            d="M200,210v-5c0-30.38-24.62-55-55-55h-50c-30.38,0-55,24.62-55,55v5h-20v20h200v-20h-20ZM60,175c0-2.76,2.24-5,5-5h110c2.76,0,5,2.24,5,5v35H60v-35Z"
          />
          <path
            className="cls-2"
            d="M45,120h20v-30h-5c0-33.08,26.92-60,60-60s60,26.92,60,60h-5v5h-5.25c.16-1.65.25-3.31.25-5,0-27.57-22.43-50-50-50s-50,22.43-50,50,22.43,50,50,50c18.47,0,34.61-10.07,43.27-25h11.73v5h20v-30h5c0-44.11-35.89-80-80-80S40,45.89,40,90h5v30ZM120,120c-16.54,0-30-13.46-30-30s13.46-30,30-30,30,13.46,30,30c0,1.7-.15,3.37-.42,5h-34.58v20h21.56c-4.75,3.16-10.44,5-16.56,5Z"
          />
        </g>
      </g>
    </svg>
  );
}
